'use client'

// @see https://nextjs.org/docs/app/guides/css-in-js#styled-jsx

import { useServerInsertedHTML } from 'next/navigation'
import type { PropsWithChildren } from 'react'
import { useState } from 'react'
import { StyleRegistry as StyleRegistryProvider, createStyleRegistry } from 'styled-jsx'

export type StyleRegistryProps = {
	nonce?: string
}

export function StyleRegistry({ nonce, children }: PropsWithChildren<StyleRegistryProps>) {
	const [registry] = useState(() => createStyleRegistry())

	useServerInsertedHTML(() => {
		const styles = registry.styles({ nonce })
		registry.flush()
		return <>{styles}</>
	})

	return <StyleRegistryProvider registry={registry}>{children}</StyleRegistryProvider>
}
